<template src="../templates/interpreterDetailsComponent.html"></template>

<script>

    export default {
        components: {},
        props: ["intId", "interpreter_id", "jobSessionId", "interpreterName", "cpnNumber","cpnNumberLabel"],
        name: "InterpreterDetailsComponent",
        data() {
            return {
                languages: [],
                accreditations: [],
                accreditationsDocs: [],
                locations: [],
                inductions: [],
                imageUrl: "",
                attendance: "",
                headerLanguages: "Session Languages",
                headerAccreditations: "Language Accreditation",
                headerLocations: "DHS Sites Attended",
                headerInductions: "DHS Site Inductions"
            }
        },
        methods: {
            gotoFile(filename, ext) {
              let route = this.$router.resolve({ path: "/viewfile?filename=" + filename + "&ext=" + ext + "&token=" + localStorage.getItem("jwt")});
              window.open(route.href);
            },
            loadData() {
                this.imageUrl = this.$publicApiURL + 'interpreter/' + this.interpreter_id + '/photo/get?token=' + localStorage.getItem('jwt');
                this.loadAttendance();
                this.loadLanguages();
                this.loadAccreditations();
            },
            loadAttendance() {
                let url = this.$localApiURL + 'interpreters/getAttendance/' + this.intId + "?token=" + localStorage.getItem("jwt");
                let self = this;
                this.$http.get(url, {
                    headers: {"Bearer": localStorage.getItem("jwt")}
                }).then((res, data) => {
                    let result = res.data;
                    if (result != null && result.attendance > 0) {
                        self.attendance = result.attendance;
                    }

				}).catch(function (error) {
					console.log(error);
				});
			},
			loadLanguages() {
				if (this.jobSessionId != null) {
					let url = this.$publicApiURL + 'interpreter/languages' + "?jobSessionID=" + this.jobSessionId + "&token=" + localStorage.getItem("jwt");
					let self = this;
					this.$http.get(url, {
						headers: {"Bearer": localStorage.getItem("jwt")}
					}).then((res, data) => {

						let result = res.data;
						self.languages = result.data;
					}).catch(function (error) {
						console.log(error);
					});
				}
			},
			loadAccreditations() {
				let url = this.$publicApiURL + 'interpreter/accreditation' + "?intID=" + this.intId + '&clientID=' + localStorage.getItem("clientID") + "&token=" + localStorage.getItem("jwt");
				let self = this;
				this.$http.get(url, {
					headers: {"Bearer": localStorage.getItem("jwt")}
				}).then(res => {

					let result = res.data;

					self.accreditations = result.data;
          self.accreditationsDocs = result.docs;

                }).catch(function (error) {
                    console.log(error);
                });
            }
        },
        created() {
            this.loadData();
        }

	}
</script>



// WEBPACK FOOTER //
// src/components/InterpreterDetailsComponent.vue